import { F0TagBalance } from '@factorialco/f0-react'

import { getCurrencySymbolFromCode } from 'modules/core/lib/formatCurrencyUtils'
import i18n from 'modules/core/lib/i18n'

interface PeriodBalanceTagProps {
  currentPeriodAmount: number
  lastPeriodAmount: number
  currency: string
}

const calculatePercentageDifference = (current: number, last: number): number => {
  if (last === 0) return 0
  return ((current - last) / last) * 100
}

const PeriodBalanceTag = ({
  currentPeriodAmount,
  lastPeriodAmount,
  currency,
}: PeriodBalanceTagProps) => {
  const notApplicableSpecialCase = lastPeriodAmount === 0

  const percentage = notApplicableSpecialCase
    ? null
    : calculatePercentageDifference(currentPeriodAmount, lastPeriodAmount)
  return (
    <>
      <F0TagBalance
        amount={
          notApplicableSpecialCase
            ? null
            : {
                numericValue: {
                  value_x100: currentPeriodAmount - lastPeriodAmount,
                  units: getCurrencySymbolFromCode(currency),
                  unitsPosition: 'append',
                },
                formatterOptions: {
                  decimalPlaces: 2,
                },
              }
        }
        nullText={i18n.t(
          'expenses_v2.reports.expenses_by_approval_status.common.not_applicable_change'
        )}
        percentage={percentage}
        hint={i18n.t('expenses_v2.reports.expenses_by_approval_status.common.vs_last_period')}
        info={
          notApplicableSpecialCase
            ? i18n.t(
                'expenses_v2.reports.expenses_by_approval_status.common.not_applicable_change_explanation'
              )
            : undefined
        }
      />
    </>
  )
}

export default PeriodBalanceTag
